import { useLayoutEffect, useRef, useState } from 'react';
import Tooltip from '../Tooltip/Tooltip';
import styles from './TruncatedOptionLabel.module.scss';

const TruncatedOptionLabel = ({ label }: { label?: string }) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        const text = textRef.current;
        if (text) setIsTruncated(text.scrollWidth > text.clientWidth);
    }, [label]);

    const text = (
        <span ref={textRef} className={styles.Text}>
            {label}
        </span>
    );

    if (!isTruncated) return text;

    return (
        <span className={styles.TooltipHost}>
            <Tooltip content={label} direction="top" fitContent usePortal containerFullWidth>
                {text}
            </Tooltip>
        </span>
    );
};

export default TruncatedOptionLabel;
